import { ColumnType } from 'antd/es/table';

interface AnyProperties {
  [prop: string]: any;
}

export interface Column extends AnyProperties {
  key: string | string[];
  title: string;
}

export class ColumnBuilder {

  public static create(items: Column[] = []) {
    return new ColumnBuilder(items);
  }

  private _align: string = 'center';
  private _items: Column[] = [];

  public constructor(items: Column[] = []) {
    this._items = items;
  }

  public setItems(items: Column[]) {
    this._items = items;
    return this;
  }

  public align(value: string) {
    this._align = value;
    return this;
  }

  public add(key: string, title: string) {
    this._items.push({ key, title });
    return this;
  }

  public build(): ColumnType<any>[] {
    return this._items.map(item => ({
      ...item,
      key: item.key,
      dataIndex: item.key,
      title: item.title,
      align: this._align
    })) as ColumnType<any>[];
  }
}

export default ColumnBuilder;
